/* Feinkost Angelo - Warenkorb: Menge aendern, ohne die Seite neu zu laden.
   Die Knoepfe bleiben echte Links. Kennt der Browser fetch, faengt dieses Skript den
   Klick ab: Die Zahl springt sofort, und danach tauscht Shopify nur den
   Warenkorb-Abschnitt aus. Geht dabei etwas schief, folgt der Browser dem Link -
   dann laeuft es wie vorher, nur langsamer. */
(function () {
  'use strict';

  if (!window.fetch || !window.DOMParser || !document.documentElement.closest) return;

  var laeuft = false;
  var wartend = null;

  function zaehler(anzahl) {
    if (typeof anzahl !== 'number') return;
    Array.prototype.forEach.call(document.querySelectorAll('.fa .nav-warenkorb-zahl'), function (el) {
      el.textContent = '(' + anzahl + ')';
    });
  }

  function senden(auftrag) {
    if (laeuft) { wartend = auftrag; return; }
    laeuft = true;

    var karte = document.querySelector('.fa .warenkorb-karte');
    if (karte) karte.classList.add('laedt');

    function fertig() {
      laeuft = false;
      var k = document.querySelector('.fa .warenkorb-karte');
      if (k) k.classList.remove('laedt');
      if (wartend) {
        var w = wartend;
        wartend = null;
        senden(w);
      }
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: auftrag.zeile,
        quantity: auftrag.menge,
        sections: auftrag.abschnitt,
        sections_url: window.location.pathname
      })
    })
      .then(function (antwort) { return antwort.json(); })
      .then(function (daten) {
        var alt = document.querySelector('[data-fa-warenkorb]');
        if (alt && daten.sections && daten.sections[auftrag.abschnitt]) {
          var gelesen = new DOMParser().parseFromString(daten.sections[auftrag.abschnitt], 'text/html');
          var neu = gelesen.querySelector('[data-fa-warenkorb]');
          if (neu) {
            /* schon sichtbar einsetzen - der Abschnitt soll nicht neu einblenden */
            Array.prototype.forEach.call(neu.querySelectorAll('.reveal'), function (el) {
              el.classList.remove('js-hidden');
              el.setAttribute('data-fa-gesehen', '1');
            });
            alt.parentNode.replaceChild(neu, alt);
          }
        }
        zaehler(daten.item_count);
        fertig();
      })
      .catch(function () {
        fertig();
        if (auftrag.zurueck) window.location.href = auftrag.zurueck;
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var link = e.target.closest('a[data-fa-menge]');
    if (!link) return;
    var wurzel = link.closest('[data-fa-warenkorb]');
    if (!wurzel) return;
    e.preventDefault();

    var zeile = parseInt(link.getAttribute('data-line'), 10);
    var richtung = link.getAttribute('data-richtung');
    var anzeige = wurzel.querySelector('[data-fa-zahl="' + zeile + '"]');
    var aktuell = anzeige ? parseInt(anzeige.value, 10) : 1;
    if (isNaN(aktuell)) aktuell = 1;

    var menge = 0;
    if (richtung === 'plus') menge = aktuell + 1;
    if (richtung === 'minus') menge = aktuell - 1;
    if (menge < 0) menge = 0;

    /* Die Zahl springt sofort - noch bevor die Antwort da ist */
    if (anzeige && menge > 0) anzeige.value = menge;

    senden({
      zeile: zeile,
      menge: menge,
      abschnitt: wurzel.getAttribute('data-fa-warenkorb'),
      zurueck: link.getAttribute('href')
    });
  });

  /* Selbst eintippen: Die Zahl ist ein Eingabefeld. Geschickt wird, sobald man das Feld
     verlaesst oder Enter drueckt. 0 entfernt den Korb, leer setzt die alte Zahl zurueck. */
  function eingabe(feld) {
    var wurzel = feld.closest('[data-fa-warenkorb]');
    if (!wurzel) return;
    var alt = parseInt(feld.getAttribute('data-alt'), 10);
    var menge = parseInt(feld.value, 10);
    if (isNaN(menge)) { feld.value = alt; return; }
    if (menge < 0) menge = 0;
    if (menge > 99) menge = 99;
    feld.value = menge;
    if (menge === alt) return;
    feld.setAttribute('data-alt', menge);
    var zeile = parseInt(feld.getAttribute('data-fa-zahl'), 10);
    senden({
      zeile: zeile,
      menge: menge,
      abschnitt: wurzel.getAttribute('data-fa-warenkorb'),
      zurueck: '/cart/change?line=' + zeile + '&quantity=' + menge
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-fa-warenkorb] input[data-fa-zahl]')) eingabe(e.target);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target || !e.target.matches) return;
    if (!e.target.matches('[data-fa-warenkorb] input[data-fa-zahl]')) return;
    /* Enter wuerde sonst das Formular abschicken und direkt zur Kasse fuehren */
    e.preventDefault();
    eingabe(e.target);
    e.target.blur();
  });

  /* Beim Antippen gleich die ganze Zahl markieren, dann tippt man einfach drueber */
  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-fa-warenkorb] input[data-fa-zahl]')) {
      setTimeout(function () { try { e.target.select(); } catch (f) {} }, 0);
    }
  });
})();
